import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Badge, Button } from 'antd'
import { FilterOutlined, SearchOutlined } from '@ant-design/icons'

import Pagination from 'components/Pagination'
import ModalSearch from 'components/Modal/ModalSearch'
import ModalFilter from 'components/Modal/QuickFilters/FilterDeviceNotifs'
import { Tag } from 'services/tags'

import { useNotifContext } from './NotifContext'

function TableListHeader() {
  const {
    loading,
    currentPage,
    totalPage,
    search,
    tags,
    dateRange,
    device,
    dispatch,
  } = useNotifContext()

  const [showSearch, setShowSearch] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  const handlePageChange = (newPage: number) => {
    dispatch({ type: 'SET_CURRENT_PAGE', payload: newPage })
  }

  const handleSearch = (value: string) => {
    if (value !== search) {
      dispatch({ type: 'SET_SEARCH', payload: value })
    }
  }

  const handleFilter = (filters: {
    dateRange?: string[]
    tags?: Tag[]
    device?: { value: number; label: string }
  }) => {
    dispatch({ type: 'SET_FILTER', payload: filters })
  }

  return (
    <React.Fragment>
      <div className='table-list-header sticky'>
        <div className='left'>
          <Pagination
            disabled={loading}
            current={currentPage}
            total={totalPage}
            onPageChange={handlePageChange}
          />
        </div>
        <div className='right'>
          <Button
            disabled={loading}
            size='large'
            className='ant-btn-secondary'
            onClick={() => setShowFilter(true)}
          >
            <Badge dot={!!tags || !!dateRange || !!device}>
              <FilterOutlined />
            </Badge>
          </Button>
          <Button
            disabled={loading}
            size='large'
            className='ant-btn-secondary'
            onClick={() => setShowSearch(true)}
          >
            <Badge dot={!!search}>
              <SearchOutlined />
            </Badge>
          </Button>
        </div>
      </div>
      <AnimatePresence>
        {showFilter && (
          <ModalFilter
            device={device}
            dateRange={dateRange}
            tags={tags}
            onChange={handleFilter}
            onCancel={() => setShowFilter(false)}
          />
        )}
        {showSearch && (
          <ModalSearch
            title='Search Notifications'
            placeholder='Search notifications'
            value={search}
            onSearch={handleSearch}
            onCancel={() => setShowSearch(false)}
          />
        )}
      </AnimatePresence>
    </React.Fragment>
  )
}

export default TableListHeader
